module.exports = __webpack_public_path__ + "img/visa-credit-card-icon-18.f9e17b8c.png";